import { Component, OnInit, Input } from '@angular/core';
import { ProgramService } from '../../services/program.service';
import { Observable } from 'rxjs/Observable';
import { Program } from '../../interfaces/program.model';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
  @Input() program: Program;
  programs = [
    {
      name: '',
      id: 0
    }
  ];

  constructor(private _programService: ProgramService) { }

  ngOnInit() {
    this._programService.get()
      .subscribe(data => this.programs = data.map(item => ({
        name: item.naam,
        id: item.id
      })));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.component.ts